import { route, tag, type PageTour } from '../pageTour';

export const modelsTour: PageTour = {
  id: 'page-models',
  version: 1,
  title: 'Model Registry',
  summary: 'The AI models available to this site and their versions.',
  match: route('/models'),
  steps: [
    {
      target: tag('models-status'),
      title: 'Active or inactive',
      description: 'Show all models, or only those currently running or switched off. The search box above finds a model by name.',
      side: 'right',
    },
    {
      target: tag('models-list'),
      title: 'Your AI models',
      description: 'Every AI model available on this site. Use the buttons on a card to attach it to a camera, edit it or remove it.',
      side: 'top',
    },
    {
      target: tag('models-add'),
      title: 'Add a model',
      description: 'Register a new AI model on this site so it can be attached to cameras.',
      side: 'bottom',
      permission: 'ai-models.add',
    },
  ],
};
